import { render, staticRenderFns } from "./FullText.vue?vue&type=template&id=d027c83a&scoped=true&"
import script from "./FullText.vue?vue&type=script&lang=ts&"
export * from "./FullText.vue?vue&type=script&lang=ts&"
import style0 from "./FullText.vue?vue&type=style&index=0&id=d027c83a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d027c83a",
  null
  
)

export default component.exports